export const gridStyle = (isMobile, columns) => ({
  display: 'grid',
  gridTemplateColumns: isMobile ? 'minmax(0, 1fr)' : columns,
  gap: 16,
  marginBottom: 16,
});
